angular.module("app")

    .factory('httpInterceptorService', ['$q', 'modalService', '$templateCache', '$injector', '$rootScope', 'logService', 'lookupCacheService', 'requestCancellationService', function ($q, modalService, $templateCache, $injector, $rootScope, logService, lookupCacheService, requestCancellationService) {
        return {
            //para qutiar cache de modal
            'request': function (request) {
                if(request.url.indexOf("Auth/Refresh") > -1) {
                    return request;
                }
                if (request.url.indexOf(".html") > 0 && request.method === 'GET' && $templateCache.get(request.url) === undefined) {
                    request.url += '?ver=' + (new Date()).getTime();
                    delete request.headers.Authorization;
                    return request;
                }

                if (request.url.indexOf("presidencia.gob.es") > -1
                    || request.url.indexOf("auth0.com") > -1
                    || request.url.indexOf("getbee.io") > -1) {
                    delete request.headers.language_code;
                }

                // Cache de catálogos invariantes durante la sesión (AB#2892).
                if (!request.cache && lookupCacheService.shouldCache(request.method, request.url)) {
                    request.cache = lookupCacheService.cache;
                }

                // Cancelar peticiones idempotentes pendientes al cambiar de ruta (AB#2897).
                // GETs sin efectos secundarios + POSTs reconocibles como búsqueda
                // (Filtered/Search/etc en la URL). Excluye flujos críticos.
                // El flag __cancelable permite al errorInterceptor distinguir
                // cancelaciones nuestras (status=-1) de pérdidas de red reales.
                let isSearchPost = request.method === 'POST'
                    && (request.url.indexOf('Filtered') > -1
                        || request.url.indexOf('Search') > -1
                        || request.url.indexOf('/Filter') > -1);
                if (!request.timeout
                        && (request.method === 'GET' || isSearchPost)
                        && request.url.indexOf('Auth/') < 0
                        && request.url.indexOf('/keepalive') < 0
                        && request.url.indexOf('update/check') < 0
                        && request.url.indexOf('.html') < 0
                        && request.url.indexOf('/lang') < 0) {
                    request.timeout = requestCancellationService.getTimeoutPromise();
                    request.__cancelable = true;
                }

                let defer = $q.defer();

                let loginService = $injector.get('LoginService');

                if(loginService.isLoggedIn() && loginService.shouldRefreshToken(request.url)) {
                    loginService.refresh().then(function (response) {
                        if(response.data.token !== undefined) {
                            request.headers.Authorization = "Bearer " + response.data.token.accessToken;
                        } else {
                            request.headers.Authorization = "Bearer " + response.data.access_token;
                        }
                        defer.resolve(request);
                    });
                } else {
                    defer.resolve(request);
                }
                return defer.promise;
            },

            'requestError': function (rejection) {
                logService.debug("requestError", rejection);
                modalService.httpError({
                    title: "Ocurrió un error en la petición",
                    message: "",
                    rejection: rejection
                });
                return $q.reject(rejection);
            },
        };
    }]);